import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ICondicionesMovimientos } from '../interfaces/CondicionesMovimientos';
import { CondicionesMovimientosService } from '../Services/condiciones-movimientos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-condiciones-movimiento-form',
  templateUrl: './condiciones-movimiento-form.component.html',
  styleUrls: ['./condiciones-movimiento-form.component.css']
})
export class CondicionesMovimientoFormComponent implements OnInit {

  public action: string;
  public condicionMovimiento: ICondicionesMovimientos;
  private condicionId: number;

  form: FormGroup;

  constructor(
      private route: ActivatedRoute,
      private condicionesMovimientosService: CondicionesMovimientosService,
      private formBuilder: FormBuilder,
      private router: Router
    ) {
      this.loadResources().then(() => this.initializeForm());

    }

    ngOnInit(): void {
  }

  private initializeForm() {
    this.form = this.formBuilder.group({
      condicion: [this.condicionMovimiento?.condicion ?? '', Validators.required],
      codigoCondicion: [this.condicionMovimiento?.codigoCondicion ?? '', Validators.required],
      movimiento: [this.condicionMovimiento?.movimiento ?? '', Validators.required],
      operacion: [this.condicionMovimiento?.operacion ?? '', Validators.required],
      codigoMovimiento: [this.condicionMovimiento?.codigoMovimiento ?? '', Validators.required]
    });
  }

  private async loadResources() {
    const params = await this.route.params.pipe(take(1)).toPromise();
    this.action = params['action'];

    if(this.action == 'edit') {
      this.condicionId = Number(params['id']);
      const condicion = await this.condicionesMovimientosService.getById(this.condicionId);
      this.condicionMovimiento = condicion
    }
  }

  public submitForm(): void {
    if(this.form.valid) {
      const condicionesMovimiento = this.mapModel();

      let request;
      if(this.action == 'add') {
        request = this.condicionesMovimientosService.create(condicionesMovimiento);
      }
      else if(this.action == 'edit') {
        request = this.condicionesMovimientosService.update(condicionesMovimiento);
      }

      request.then(resp => Swal.fire('Listo', 'Condicion de movimiento guardada satisfactoriamente', 'success'))
        .then(() => {
          this.form.reset();
          this.goBack();
        });
      }
  }

  public goBack() {
    this.router.navigate(['home/registro/CondicionesMovimientos']);
  }

  private mapModel(): ICondicionesMovimientos {
    const controls = this.form.controls;

    const condicionMovimiento: ICondicionesMovimientos = {
      codigoCondicion: controls.codigoCondicion.value,
      codigoMovimiento: controls.codigoMovimiento.value,
      condicion: controls.condicion.value,
      movimiento: controls.movimiento.value,
      operacion: Number(controls.operacion.value),
      id: this.condicionId
    };

    return condicionMovimiento;
  }

  invalidField(fieldName: string): boolean {
    return this.form.get(fieldName).invalid && this.form.get(fieldName).touched;
  }
}
